module.exports = __webpack_public_path__ + "img/17857_S.b0f051bd.png";